"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVendorApi = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
/**
 * Vendor API factory — see createTicketApi.ts for the shared-package baseQuery-injection pattern.
 */
const createVendorApi = (baseQuery) => (0, react_1.createApi)({
    reducerPath: 'vendorApi',
    baseQuery,
    tagTypes: ['Vendor', 'VendorList'],
    endpoints: (builder) => ({
        getVendorById: builder.query({
            query: (id) => ({
                url: 'Vendor',
                params: { id },
            }),
            providesTags: (_result, _error, id) => [{ type: 'Vendor', id }],
        }),
        getActiveVendors: builder.query({
            query: () => ({
                url: 'VendorsActive',
            }),
            providesTags: ['VendorList'],
        }),
        upsertVendor: builder.mutation({
            query: (body) => ({
                url: 'Vendor',
                method: 'POST',
                body,
            }),
            invalidatesTags: (_result, _error, arg) => [
                'VendorList',
                { type: 'Vendor', id: arg.vendorView.id || 'NEW' },
            ],
        }),
    }),
});
exports.createVendorApi = createVendorApi;
